<div class="dialog-delete-new-schedule-suggestion">
  <span class="dialog-delete-new-schedule-suggestion__title">
    {{ 'MAINTENANCES.SCHEDULE_SUGGESTIONS.CONFIRM_DELETE_NEW_SCHEDULE_SUGGESTIONS.TITLE' | translate }}
  </span>
  <span class="dialog-delete-new-schedule-suggestion__description">
    {{ 'MAINTENANCES.SCHEDULE_SUGGESTIONS.CONFIRM_DELETE_NEW_SCHEDULE_SUGGESTIONS.DESCRIPTION' | translate }}
  </span>
  <div class="dialog-delete-new-schedule-suggestion__buttons">
    <button class="dialog-delete-new-schedule-suggestion__buttons__confirm" (click)="deleteAllSchedulingSuggestions()">
      {{ 'MAINTENANCES.SCHEDULE_SUGGESTIONS.CONFIRM_DELETE_NEW_SCHEDULE_SUGGESTIONS.CONFIRM' | translate }}
    </button>
    <button class="dialog-delete-new-schedule-suggestion__buttons__cancel" (click)="closeDialog()">
      {{ 'MAINTENANCES.SCHEDULE_SUGGESTIONS.CONFIRM_DELETE_NEW_SCHEDULE_SUGGESTIONS.CANCEL' | translate }}
    </button>
  </div>
</div>
